import styled from 'styled-components';
import { COLOR, TYPOGRAPHY } from '../../theme/constants';

export const BecomeAClientWrapper = styled.div`
   position: relative;
   box-sizing: border-box;
   z-index: 0;
   height: 300px;
   width: 360px;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   padding: 25px 30px;

   @media only screen and (max-width: 1200px) {
      display: none;
   }

   @media only screen and (max-width: 1340px) {
      padding: 20px 24px;
      width: 320px;
      height: 240px;
   }
`;

export const BecomeAClientBackground = styled.div`
   position: absolute;
   top: 0;
   left: 0;
   width: 100%;
   height: 100%;
   background-color: ${COLOR.BLACK_BACKGROUND};
   z-index: -2;
`;

export const BecomeAClientImageContainer = styled.div`
   position: absolute;
   top: 0;
   left: 0;
   display: flex;
   align-items: center;
   height: 100%;
   margin: auto 0;
   z-index: -1;
`;

export const BecomeAClientImage = styled.img`
   width: 100%;
   height: 100%;
`;

export const BecomeAClientHeader = styled.div`
   color: ${COLOR.WHITE};
   font-size: 30px;
   ${TYPOGRAPHY.BLACK}

   @media only screen and (max-width:1340px) {
      font-size: 24.4px;
   }
`;

export const BecomeAClientHeaderSpan = styled.span`
   color: ${COLOR.RED};
`;

export const BecomeAClientInfo = styled.p`
   margin-top: -24px;
   color: ${COLOR.LIGHTGREY};
   font-size: 18px;

   @media only screen and (max-width: 1340px) {
      margin-top: -18px;
      font-size: 14.6px;
   }
`;

export const BecomeAClientSubmit = styled.div`
   padding: 14px 0;

   @media only screen and (max-width: 1340px) {
      padding: 11px 0;
   }
`;

export const BecomeAClientButton = styled.a`
   background-color: ${COLOR.BLUE};
   border-radius: 25px;
   color: ${COLOR.WHITE};
   font-size: 14px;
   ${TYPOGRAPHY.BLACK}
   padding: 12px 28px;
   text-align: center;
   text-decoration: none;

   &:hover {
      background-color: ${COLOR.BLUE_HOVER};
   }

   @media only screen and (max-width: 1340px) {
      font-size: 11.4px;
      padding: 11px 29px;
   }
`;
